import { render, staticRenderFns } from "./UINewsletterSection.vue?vue&type=template&id=31bd4d2d&scoped=true&"
import script from "./UINewsletterSection.vue?vue&type=script&lang=ts&"
export * from "./UINewsletterSection.vue?vue&type=script&lang=ts&"
import style0 from "./UINewsletterSection.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./UINewsletterSection.vue?vue&type=style&index=1&id=31bd4d2d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd4d2d",
  null
  
)

export default component.exports